import { loginPasswordRegex, loginUsernameRegex } from "src/utils/regex";
import * as yup from "yup";

/************************ login validations ************************/
export default yup.object().shape({
  username: yup
    .string()
    .trim()
    .min(2, "تعداد کاراکتر واردشده کمتر از حد مجاز است.")
    .max(50, "تعداد کاراکتر واردشده بیشتر از حد مجاز است.")
    .required("لطفاً نام کاربری خود را وارد کنید.")
    .matches(loginUsernameRegex, "لطفا  نام کاربری خود را با حروف لاتین وارد کنید"),
  password: yup
    .string()
    .trim()
    .required("لطفاً رمز عبور خود را وارد کنید.")
    .min(8, "تعداد کاراکتر واردشده کمتر از حد مجاز است.")
    .max(20, "تعداد کاراکتر واردشده بیشتر از حد مجاز است.")
    .matches(loginPasswordRegex, "لطفا رمز عبور خود را با حروف لاتین وارد کنید"),
});
